import Axios from 'axios';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';
import GeneralAction from '../Actions/GeneralAction';
import Apis from '../Apis';
import CompanyActions from '../Actions/CompanyActions';


class CompanyMiddleware {

  static getCompany = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search || userData?.next_page_url == undefined) {
            if (userData?.search && userData?.next_page_url) {
            }
            else {
              dispatch(CompanyActions.clearComapny())
            }
          }
          let formdata = new FormData()
          formdata.append('name', userData?.search);
          const { data } = await Axios.post(
            Apis.companies(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(CompanyActions.getComapny(data?.data))
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static createCompany = (companydata) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('name', companydata?.CompanyName);
          formdata.append('address', companydata?.CompanyAddress);
          formdata.append('lat', companydata?.CompanyLat);
          formdata.append('lng', companydata?.CompanyLng);
          formdata.append('contact_no', companydata?.CompanyContact);
          if (companydata?.CompanySite) formdata.append('website', companydata?.CompanySite)
          const { data } = await Axios.post(
            Apis.createCompany,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(CompanyActions.updateComapny(data?.data))
            dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static editCompany = (companydata) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', companydata?.CompanyID);
          formdata.append('name', companydata?.CompanyName);
          formdata.append('address', companydata?.CompanyAddress);
          formdata.append('lat', companydata?.CompanyLat);
          formdata.append('lng', companydata?.CompanyLng);
          formdata.append('contact_no', companydata?.CompanyContact);
          if (companydata?.CompanySite) formdata.append('website', companydata?.CompanySite)
          const { data } = await Axios.post(
            Apis.updateCompany,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(CompanyActions.editComapny(data?.data))
            dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }
  static getCompanyForCustomer = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.post(
            Apis.companies_list,
            {},
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

}

export default CompanyMiddleware;